import useOpportunity from '@/hooks/swr/useOpportunity';
import useCampaign from '@/lib/hooks/swr/useCampaign';
import useConstituent from '@/lib/hooks/swr/useConstituent';
import usePreselectedLabels from '@/lib/hooks/swr/usePreselectedLabels';

export default function useOpportunityData(opportunityId: null | string) {
  const { data: opportunity } = useOpportunity(opportunityId || null);
  const { constituentId, campaignId } = opportunity || {};
  const needsConstituent = !!constituentId;
  const needsCampaign = !!campaignId;
  const { data: campaign } = useCampaign(campaignId || '');
  const { data: constituent } = useConstituent(constituentId);
  const tags = opportunity?.labels?.tags || [];
  const { data: labels } = usePreselectedLabels(tags);

  return {
    campaign,
    constituent,
    labels,
    opportunity,
    hasData:
      !!opportunity &&
      (needsConstituent ? !!constituent : true) &&
      (needsCampaign ? !!campaign : true) &&
      (tags?.length ? !!labels : true),
  };
}
